/**
 * Build Gmail web URLs for a synced conversation (multi-login aware).
 *
 * Order: saved numeric slot (mail/u/N/) → authuser=mailbox email → fallback u/0.
 */

export type GmailThreadDeepLinkParams = {
    threadId: string | null | undefined;
    mailboxEmail: string | null | undefined;
    gmailWebAuthuserIndex: number | null | undefined;
};

export function buildGmailThreadDeepLink(params: GmailThreadDeepLinkParams): string {
    const tid = params.threadId?.trim();
    const idx = params.gmailWebAuthuserIndex;

    if (typeof idx === 'number' && Number.isInteger(idx) && idx >= 0 && idx <= 7) {
        if (tid) {
            return `https://mail.google.com/mail/u/${idx}/#inbox/${encodeURIComponent(tid)}`;
        }
        return `https://mail.google.com/mail/u/${idx}/#inbox`;
    }

    const email = params.mailboxEmail?.trim();
    if (email) {
        const qs = new URLSearchParams({ authuser: email });
        const hash = tid ? `#inbox/${encodeURIComponent(tid)}` : '#inbox';
        return `https://mail.google.com/mail/?${qs.toString()}${hash}`;
    }

    if (tid) {
        return `https://mail.google.com/mail/u/0/#inbox/${encodeURIComponent(tid)}`;
    }
    return 'https://mail.google.com/mail/u/0/#inbox';
}
